
import { computed, defineComponent } from '@vue/runtime-core'
import HeadingLv3 from '@/components/elements/HeadingLv3.vue'
import Tag from '@/components/elements/Tag.vue'
import Button from '@/components/elements/Button.vue'
import { dateFormat, getEventTerm } from '@/utils/commonMethods'

export default defineComponent({
  name: 'EventCardHospital',

  components: {
    HeadingLv3,
    Button,
    Tag
  },

  props: {
    event: {
      type: Object,
      default: () => ({})
    }
  },

  setup(props) {
    const eventType = computed(() => {
      if (props.event.type === 'オンライン' || props.event.type === 'online') {
        return 'オンライン'
      }
      return 'オフライン'
    })

    const mainEventLabel = computed(() => {
      if (
        props.event.event_category.find(
          (cat: { name: string }) => cat.name === 'キャリアガイダンス'
        )
      ) {
        return 'キャリアガイダンス'
      }
      return eventType.value
    })

    const categoryIcon = computed(() => {
      if (mainEventLabel.value === 'キャリアガイダンス') {
        return require('@/assets/images/icon/book-white.svg')
      }
      if (mainEventLabel.value === 'オンライン') {
        return require('@/assets/images/icon/pc-white.svg')
      }
      if (mainEventLabel.value === 'オフライン') {
        return require('@/assets/images/icon/hospital-02-white.svg')
      }
    })

    const eventTypeClass = computed(() => {
      if (mainEventLabel.value === 'キャリアガイダンス') return 'isCareer'
      if (mainEventLabel.value === 'オンライン') return 'isOnline'
      if (mainEventLabel.value === 'オフライン') return 'isOffline'
    })

    const eventPlace = computed(() => {
      if (eventType.value === 'オンライン' && props.event.place_name) {
        return props.event.place_name
      }
      if (eventType.value === 'オフライン') {
        return `${props.event.place_name}(${props.event.place_prefecture}${props.event.place_city})`
      }
      return ''
    })

    const tags = computed(() => {
      if (props.event.tags) return props.event.tags
      const res = []
      if (props.event.benefits) res.push('イベント特典あり')
      if (props.event.seminar && props.event.seminar.length > 0) {
        res.push('セミナーあり')
      }
      return res
    })

    const latestSeminar = computed(() => {
      if (props.event.seminar.length === 0) return []
      const lastItemIndex = props.event.seminar.length - 1
      return [props.event.seminar[lastItemIndex]]
    })

    const category = computed(() => {
      const categories: { name: string }[] = props.event.event_category
      if (categories.some((cat) => cat.name === 'キャリアガイダンス')) {
        return 'キャリアガイダンス'
      }
      return categories?.length ? categories[0].name : ''
    })

    return {
      dateFormat,
      getEventTerm,
      eventTypeClass,
      categoryIcon,
      mainEventLabel,
      eventPlace,
      category,
      tags,
      latestSeminar
    }
  }
})
